import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-overlay" }




export default /*@__PURE__*/_defineComponent({
  __name: 'OverlayLoader',
  props: ['loading'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, null, 512)), [
    [_vShow, __props.loading]
  ])
}
}

})